import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideDownload, lucidePen, lucidePlus, lucideTrash } from '@ng-icons/lucide';
import { PaginateurComponent } from '@shared/components/paginateur/paginateur.component';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { TrigrammeTypeCertification } from '../models/trigramme-type-certification.model';
import { TrigrammeTypeCertificationStore } from '../store/trigrammes-type-certification.store';
import { FormTrigrammeTypeCertificationComponent } from './form/form-trigramme-type-certification.component';

@Component({
  selector: 'app-gestion-trigramme-certification-list',
  imports: [
    PaginateurComponent,
    ReactiveFormsModule,
    HlmTableImports,
    HlmTooltipImports,
    HlmCardImports,
    HlmIconImports,
    HlmButtonImports,
  ],
  templateUrl: './gestion-trigramme-certification-list.component.html',
  providers: [provideIcons({ lucidePen, lucideTrash, lucidePlus, lucideDownload })],
})
export class GestionTrigrammesTypeCertificationList implements OnInit {
  readonly trigrammeStore = inject(TrigrammeTypeCertificationStore);
  readonly #sidepanelService = inject(SidepanelService);

  entities = computed(() => this.trigrammeStore.getPaginated());
  trigrammes = computed(() => this.trigrammeStore.entities());

  readonly isLoading = signal(false);

  ngOnInit(): void {
    this.trigrammeStore.charger();
  }

  delete(idTrigramme: string) {
    this.trigrammeStore.supprimer(idTrigramme);
  }

  export() {
    this.isLoading.set(true);
    this.trigrammeStore.export({
      next: (blob: Blob) => this.downloadCSV(blob),
      error: () => this.isLoading.set(false),
    });
  }

  downloadCSV(blob: Blob) {
    const filename = 'export-trigrammes-type-certification.csv';

    const downloadLink = document.createElement('a');
    const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv;charset=utf-8' }));
    downloadLink.href = url;
    downloadLink.download = filename;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    URL.revokeObjectURL(url);
    this.isLoading.set(false);
  }

  ajouterTrigramme() {
    this.#sidepanelService.setComponentToDisplay(
      'Ajouter un trigramme',
      FormTrigrammeTypeCertificationComponent,
      `Vous pouvez créer un trigramme ou en créer plusieurs d’un seul coup.`,
    );
    this.#sidepanelService.open();
  }

  edit(trigrammeType: TrigrammeTypeCertification) {
    this.#sidepanelService.setComponentToDisplay(
      'Modifier le trigramme',
      FormTrigrammeTypeCertificationComponent,
      `Vous pouvez modifier le trigramme sélectionné.`,
      { trigrammeType },
    );
    this.#sidepanelService.open();
  }
}
